import { render, staticRenderFns } from "./lavestock-history.vue?vue&type=template&id=8634b1f0"
import script from "./lavestock-history.vue?vue&type=script&lang=ts"
export * from "./lavestock-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports